var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 56.9C27.275 56.9 24.575 56.1 22.45 54.525L11.7 46.5C8.85 44.375 6.625 39.925 6.625 36.4V17.8C6.625 13.95 9.45 9.84998 13.075 8.49998L25.55 3.82498C28.025 2.89998 31.925 2.89998 34.4 3.82498L46.875 8.49998C50.5 9.84998 53.325 13.95 53.325 17.8V36.375C53.325 39.925 51.1 44.35 48.25 46.475L37.5 54.5C35.425 56.1 32.725 56.9 30 56.9ZM26.875 7.34998L14.4 12.025C12.275 12.825 10.4 15.525 10.4 17.825V36.4C10.4 38.775 12.075 42.1 13.95 43.5L24.7 51.525C27.575 53.675 32.425 53.675 35.325 51.525L46.075 43.5C47.975 42.075 49.625 38.775 49.625 36.4V17.8C49.625 15.525 47.75 12.825 45.625 12L33.15 7.32498C31.45 6.72498 28.55 6.72498 26.875 7.34998Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.65 35.575C26.175 35.575 25.7 35.4 25.325 35.025L21.3 31C20.575 30.275 20.575 29.075 21.3 28.35C22.025 27.625 23.225 27.625 23.95 28.35L26.65 31.05L36.075 21.625C36.8 20.9 38 20.9 38.725 21.625C39.45 22.35 39.45 23.55 38.725 24.275L27.975 35.025C27.6 35.4 27.125 35.575 26.65 35.575Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.9d330ed840daa6535d4f187ff8f18606.svg";
export { ForwardRef as ReactComponent };